import { getNextApiRoute, typedFetch } from '@libs/common-next';
import type { IdentityRouteAuthResponse } from './identity';

export const handleLogout = async () => {
    const res = await typedFetch<IdentityRouteAuthResponse>(getNextApiRoute(`auth/logout`), {
        method: 'POST',
    });

    return !!res?.success;
};
